module.exports = __webpack_public_path__ + "assets/img/hzhb_pls.4f5fc715.png";